module.exports = __webpack_public_path__ + "img/kid8.da811d74.png";